export function megaMenu() {
  const pageHeader = document.querySelector('.page-header__main');
  const megaMenu = document.querySelector('.mega-menu');
  const megaMenuItemClass = '.mega-menu__item';
  const megaMenuOpenClass = 'mega-menu--open';
  const navLinks = document.querySelectorAll('#menu-primary-navigation .nav-link');
  const megaMenuLinks = document.querySelectorAll('.mega-menu__links .menu-item-has-children');
  const navLinkActiveClass = 'active';
  const navLinkCurrentClass = 'current';
  const dflexClass = 'd-flex';

  window.addEventListener('resize', resizeListener);

  function resizeListener() {
    if (window.innerWidth < 992) {
      megaMenu.classList.remove(megaMenuOpenClass);
    }
  }

  navLinks.forEach((item, index) => {
    item.addEventListener('click', e => {
      e.preventDefault();

      let currentItemIndex = index;
      let url = e.target.getAttribute('href');

      megaMenuLinks.forEach((item, index) => {
        item.classList.remove(dflexClass);
        if(currentItemIndex === index) {
          item.classList.add(dflexClass);
        }
      });

      if (e.target.classList.contains(navLinkActiveClass)) {
        if (e.target.pathname === window.location.pathname) {
          e.target.classList.toggle(navLinkCurrentClass);
          megaMenu.classList.toggle(megaMenuOpenClass);
        }
        else {
          e.target.classList.remove(navLinkActiveClass);
          megaMenu.classList.remove(megaMenuOpenClass);
        }
      }
      else {
        navLinks.forEach(item => {
          item.classList.remove(navLinkActiveClass);
        });

        e.target.classList.add(navLinkActiveClass);
        megaMenu.classList.add(megaMenuOpenClass);
      }

      document.querySelectorAll(megaMenuItemClass).forEach(item => {
        item.classList.remove(dflexClass);

        if (item.getAttribute('data-url') === url) {
          item.classList.add(dflexClass);
        }
      });
    })
  });

  document.addEventListener('click', function (e) {
    if (!pageHeader.contains(e.target)) {
      megaMenu.classList.remove(megaMenuOpenClass);

      let activeItem = null;

      navLinks.forEach(item => {
        if (item.pathname === window.location.pathname) {
          activeItem = item;
        }
        else {
          item.classList.remove(navLinkActiveClass);
        }

        if (activeItem) {
          activeItem.classList.add(navLinkActiveClass);
          activeItem.classList.remove(navLinkCurrentClass);
        }
      });
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/megaMenu.js